import { HEADER_NAV_SOURCE } from '../../constants';

/**
 * Returns object with source query param
 *
 * @param {*} params query params
 * @returns {Object}
 */
export function pathfinderQueryEnrichment(params = {}) {
    return {
        query: {
            source: HEADER_NAV_SOURCE,
            ...params,
        },
    };
}
